const getProductType = (productTypeExtractCode: string): string | undefined => {
  try {
    const map = new Function(productTypeExtractCode);
    return map();
  } catch (e) {
    console.error(`error to get product type productTypeExtractCode reason:${(e as Error).message}`);
  }
};
export default getProductType;
